// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"9f92c2a6","778":"900aa58a"}[chunkId] + ".chunk.js";
};